import { Button, Checkbox, Col, Form, Input, Row, Select, Switch, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import useToastContext from '../../hooks/useToastContext';
import useUpdateEmbossCardAffinityGroup from '../../hooks/update/useUpdateEmbossCardAffinityGroup';
import { CardProductType, mastercardDesigns, ProductType, visaDesigns } from '../../interfaces/card-products';
import { SwitchContainer } from '../../pages/issuer/card-product';
import { FirstStepFormInputs } from '../CardAffinityGroups/new/first-step';

export type EmbossFormInputs = {
  design: string;
  // eslint-disable-next-line camelcase
  commercial_bin: boolean;
  // eslint-disable-next-line camelcase
  recording_code: number;
  // eslint-disable-next-line camelcase
  card_product_type: string;
  product: string;
  logo: string;
};

const Emboss = ({
  cardAffinityGroupId,
  emboss,
  setEmboss,
  action,
  submitForm
}: {
  cardAffinityGroupId?: string | null;
  emboss?: EmbossFormInputs | null;
  setEmboss?: (value: EmbossFormInputs) => void | undefined;
  action?: string | null;
  submitForm?: boolean | undefined;
}) => {
  const toast = useToastContext();
  const [formEmboss] = Form.useForm();
  const values = Form.useWatch([], formEmboss);
  const [commercialBin, setCommercialBin] = useState(true);
  const { putError, putLoading, executePut } = useUpdateEmbossCardAffinityGroup(cardAffinityGroupId);

  useEffect(() => {
    if(action === 'view' || action === 'edit') {
      formEmboss.setFieldValue('design', emboss?.design);
      setCommercialBin(emboss?.commercial_bin);
      formEmboss.setFieldValue('recording_code', emboss?.recording_code);
      formEmboss.setFieldValue('card_product_type', emboss?.card_product_type);
      formEmboss.setFieldValue('logo', emboss?.logo);
      formEmboss.setFieldValue('product', emboss?.product);
    }
  }, [emboss]);

  useEffect(() => {
    if(submitForm) {
      formEmboss.submit();
    }
  }, [submitForm]);

  const onSubmitEmboss = async (data: EmbossFormInputs) => {
    data.commercial_bin = commercialBin;
    if(cardAffinityGroupId !== undefined && cardAffinityGroupId !== null) {
      try {
        const response = await executePut({ data: data });

        if (response.status === 200) {
          toast.success('Exito', 'Grupo de afinidad actualizado correctamente!.');
        } else {
          throw new Error();
        }
      } catch (e: unknown) {
        toast.error('Error', `Ocurrió un error: ${putError}, porfavor, intenta nuevamente.`);
      }
    } else {
      if(setEmboss !== undefined) {
        setEmboss(data);
      }
    }
  }

  return (
    <Form<EmbossFormInputs>
      name="basic"
      layout="vertical"
      form={formEmboss}
      onFinish={onSubmitEmboss}
      onFinishFailed={console.log}
      style={{ maxWidth: '100%' }}
    >
      <Row>
        <Typography.Title level={3} style={{ marginTop: '20px', marginBottom: '20px' }}>Configuración de embozado</Typography.Title>
      </Row>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item<EmbossFormInputs>
            name={'card_product_type'}
            label={'Tipo de Card Product'}
            rules={[{ required: true, message: 'Por favor seleccionar tipo.' }]}
          >
            <Select
              disabled={ action === 'view' }
              placeholder="Seleccionar tipo"
              options={CardProductType}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<EmbossFormInputs>
            name={'product'}
            label={'Categoria de tarjeta'}
            rules={[{ required: true }]}
          >
            <Select
              disabled={ action === 'view' }
              placeholder="Seleccionar tipo"
              options={ProductType}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<EmbossFormInputs>
            name={'design'}
            label={'Diseño'}
            rules={[{ required: true, message: 'Por favor seleccionar diseño.' }]}
          >
            <Select
              disabled={ action === 'view' }
              placeholder="Seleccionar diseño"
              options={visaDesigns?.concat(mastercardDesigns)}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<EmbossFormInputs>
            name={'logo'}
            label={'Logo'}
          >
            <Input
              disabled={ action === 'view' }
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item<EmbossFormInputs>
            name={'recording_code'}
            label={'Codigo de grabación'}
            rules={[{ min: 0, max: 9999, required: true, message: 'Por favor ingresar código de grabación.' }]}
          >
            <Input
              type={"number"}
              disabled={ action === 'view' }
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item<EmbossFormInputs>
            name={'commercial_bin'}
            label="Es bin comercial?"
            layout="horizontal"
          >
            <Checkbox disabled={ action === 'view' } checked={commercialBin} onChange={() => setCommercialBin(!commercialBin)} />
          </Form.Item>
        </Col>
      </Row>
      {
        action === 'edit' && cardAffinityGroupId !== undefined ? (
          <Row gutter={24}>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button
                type="primary"
                htmlType="submit"
                loading={ putLoading }
              >
                Guardar
              </Button>
            </Col>
          </Row>
        ) : ''
      }
    </Form>
  );
};

export default Emboss;